import Agent from 'agentkeepalive';
import { CONTACTS_SERVICE_KEY, DB_ORIGIN_VERSION_HEADER } from './constants';
import { DB_TARGET_VERSION } from '@onereach/types-contacts-api';
const buildHttpAgents = () => {
    const socketsPoolOptions = {
        maxSockets: 100,
        maxFreeSockets: 10,
        timeout: 60000,
        freeSocketTimeout: 30000,
    };
    const httpAgent = new Agent(socketsPoolOptions);
    const httpsAgent = new Agent.HttpsAgent(socketsPoolOptions);
    return {
        httpAgent,
        httpsAgent,
    };
};
export const extractTargetDbVersion = (params) => {
    return params['dbTargetVersion'] || DB_TARGET_VERSION;
};
const buildInterceptors = (params) => {
    const targetVersion = extractTargetDbVersion(params);
    const { dbVersionMismatchCallback = () => { } } = params;
    return {
        response: (response) => {
            const originVersion = response.headers[DB_ORIGIN_VERSION_HEADER];
            if (originVersion !== targetVersion) {
                dbVersionMismatchCallback(targetVersion, originVersion);
            }
            return response;
        },
    };
};
export const buildBaseConfig = (params) => {
    const { token, discoveryUrl, contactsApiUrl, accountId, withKeepAliveAgents } = params;
    return Object.assign(Object.assign({ token,
        discoveryUrl, serviceKey: CONTACTS_SERVICE_KEY, serviceUrl: contactsApiUrl, accountId }, (withKeepAliveAgents ? { httpAgents: buildHttpAgents() } : {})), { interceptors: buildInterceptors(params) });
};
export default buildBaseConfig;
//# sourceMappingURL=baseConfigFactory.js.map